<div class="p-mt-5">
  <div class="search-container">
    <div class="search-query-wrapper">
      <div class="search-query">
        <dx-text-box
          id="mobileNumber"
          [style]="{ width: '225px' }"
          placeholder="Search"
          [(value)]="searchQuery"
          (onKeyDown)="handleKeyDown($event)"
          (onFocusIn)="onInputFocus()"
          (onFocusOut)="onInputBlur()"
          (onValueChanged)="onValueChanged($event)"
          >
        </dx-text-box>
        <!-- Cached searches dropdown -->
        <div class="cached-searches-dropdown" *ngIf="showCachedSearches && cachedSearches.length > 0">
          <div class="cached-searches-header">Recent Searches</div>
          <div
            class="cached-search-item"
            *ngFor="let cachedSearch of cachedSearches"
            (click)="selectCachedSearch(cachedSearch)">
            <fa-icon [icon]="faHistory"></fa-icon>
            <span>{{ cachedSearch }}</span>
          </div>
        </div>
      </div>
      <div *ngIf="displayError">
        <small class="p-error">Please enter 3 or more characters</small>
      </div>
    </div>

    <div class="search-btn-group">
      <dx-button
        text="Search"
        stylingMode="contained"
        type="default"
        [disabled]="!searchQuery || searchQuery.length < 3"
        icon=""
        (click)="searchBtn()">
      </dx-button>
      <dx-button
        text="Reset"
        stylingMode="outlined"
        type="normal"
        class="reset-button"
        icon=""
        (click)="resetSearch()">
      </dx-button>
    </div>
  </div>
</div>

